import { lorem } from "faker/locale/en_US";

import type { Db } from "./types";
import { randomDate } from "./utils";

export const generateDealNotes = (db: Db, size = 3) => {
  return Array.from(Array(size).keys()).map((id) => {
    const deal = db.deals[id % db.deals.length] || db.deals[0];
    return {
      id,
      deal_id: deal.id,
      text: lorem.paragraph(),
      date: randomDate(new Date(deal.created_at)).toISOString(),
      sales_id: deal.sales_id,
    };
  });
};
